import { ethers } from "ethers";
import abi from "./abi";

const { formatEther, parseEther } = ethers.utils;

export const address = "0xD1f49F4882860bB311ff549F4393B9AdAa82Ab64";

export const handleMint = async (
	mintInputAmount,
	provider,
	setManualError,
	setInfoMessage,
	setLoading,
	error,
	setFundsError,
	setDeniedError
) => {
	// json rpc signer
	try {
		const ethersProvider = ethers.getDefaultProvider();
		// ethers contract instance
		const contract = new ethers.Contract(address, abi, ethersProvider);

		// getting token cost, don't need to hardcode the value
		const _tokenCost = await contract.getCost();
		const tokenCost = formatEther(_tokenCost);
		const totalTokenTxCost = (+(Number(tokenCost) * mintInputAmount).toFixed(5)).toString();

		const signer = provider.getSigner();
		const _contract = contract.connect(signer);

		setInfoMessage("");
		const mint = await _contract
			.mint(await signer.getAddress(), mintInputAmount, {
				value: parseEther(totalTokenTxCost),
			})
			// .catch((e) => {
			// 	if (e && e.code && e.code === 4001) {
			// 		setDeniedError("User denied the request");
			// 	} else if (e && e.error && e.error.message) {
			// 		console.log(e);
			// 		setManualError(e.error.message);
			// 	}
			// });
		setLoading(true);
		const txReceipt = mint && (await mint.wait());

		txReceipt &&
			txReceipt.transactionHash &&
			setInfoMessage(`https://etherscan.io/tx/${txReceipt.transactionHash}`);
		setLoading(false);
	} catch (e) {
		setLoading(false);
		if (e && e.error && e.error.message && e.error.message.includes("insufficient funds for gas")) {
			console.log(e);
			setFundsError("Insufficient funds");
		} else if (e && e.error) {
			console.log(e);
			setManualError(e && e.error && e.error.message);
		} else if (e && e.code && e.code === 4001) {
			setDeniedError("User denied the request");
		} else {
			console.log(e);
			setManualError("Error");
		}
	}
};
